import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=6a6ada5d"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wedevs/Herd/dokan-core/wp-content/plugins/dokan-pro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6ada5d')) {
      api.createRecord('6a6ada5d', component.options)
    } else {
      api.reload('6a6ada5d', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=6a6ada5d", function () {
      api.rerender('6a6ada5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/request-for-quotation/assets/src/js/admin/components/Tabs.vue"
export default component.exports